import './AppFooter.css';

const MARKETING_URL = process.env.REACT_APP_MARKETING_URL || 'https://dopedash.app';

function AppFooter() {
  return (
    <footer className="dd-footer">
      <div className="dd-container dd-footer-inner">
        <p className="dd-footer-tagline">
          Dope Dash. Your daily hit of accomplishment. Feel the Fix of Finished.
        </p>
        <nav className="dd-footer-links">
          <a href={MARKETING_URL} target="_blank" rel="noopener noreferrer">
            🌐 Website
          </a>
          <a href={`${MARKETING_URL}/docs`} target="_blank" rel="noopener noreferrer">
            📚 Documentation
          </a>
          <a href={`${MARKETING_URL}/changelog`} target="_blank" rel="noopener noreferrer">
            📝 Changelog
          </a>
          <a href={`${MARKETING_URL}/about`} target="_blank" rel="noopener noreferrer">
            ℹ️ About
          </a>
        </nav>
      </div>
    </footer>
  );
}

export default AppFooter;
